import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ListAltIcon from '@material-ui/icons/ListAlt';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Slide from '@material-ui/core/Slide';
import i18next from 'i18next';

import TabBankSummary from '../TabBankSummary';
import VacationBankSummary from './VacationBankSummary';
import VacationBankDetail from './VacationBankDetail';
import { resizeComponent } from '../../../utils';
import { IsEnglish } from '../../../utils/language';
import styles from '../../../styles/bankBalance.module.css';

const useStyles = makeStyles((theme) => ({
    firstCell: {
        width: '350px',
        '@media (max-width: 600px)': {
            width: "60px",
            paddingLeft: '52px'
        },
        textAlign: 'left',
        float: 'left',
        marginTop: '12px'
    },
    secondCell: {
        width: '350px',
        '@media (max-width: 600px)': {
            width: "120px"
        },
        float: 'left',
        marginTop: '12px'
    },
    appBar: {
        position: 'relative',
    },
    accordionSummary: {
        color: 'var(--color2) !important'
    },
    iconExpand: {
        color: 'var(--color2) !important'
    }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function AllVacationBankBalance(props) {
    const classes = useStyles();

    const [dataBank, setDataBank] = React.useState(null);
    const [dataDetailBank, setDataDetailBank] = React.useState(null);
    const [expanded, setExpanded] = React.useState(null);
    const [title, setTitle] = React.useState('');
    const [open, setOpen] = React.useState(false);

    const { data } = props;

    useEffect(() => {
        loadData();
        resizeComponent('div[data-id=headerAllVacationBankBalance]', '#divAllVacationBankBalance');
    }, []);

    const loadData = () => {
        setDataBank(data);
    }

    const handleAccordion = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const handleOpenDetail = (event, year) => {
        event.preventDefault();
        event.stopPropagation();
        var bank = dataBank.filter(item => item.year === year)[0];
        if (bank !== undefined) {
            setDataDetailBank(bank.bankVacationDetail);
        }
        setTitle(`${year} - ${i18next.t('bankBalance:form.vacation')}`)
        setOpen(true);
    };

    const handleCloseClick = () => {
        setOpen(false);
    }

    return (
        <div id="divAllVacationBankBalance" className={styles.rootBankBalance}>
            {dataBank != null && dataBank.map((obj, index) =>
                <React.Fragment key={index}>
                    <Accordion className={classes.accordionSummary} expanded={expanded === index} onChange={handleAccordion(index)}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon className={classes.iconExpand} />}
                            aria-controls={`panel2${index}-content`}
                            id={`panel${index}-header`}
                        >
                            <div className={classes.firstCell}>{obj.year}</div>
                            <div className={classes.secondCell}>{IsEnglish() ? obj.bankEn : obj.bankFr}</div>
                            <div className={classes.thirdCell}>
                                <IconButton edge="start" color="inherit" onClick={(event) => handleOpenDetail(event, obj.year)} aria-label="close">
                                    <ListAltIcon />
                                </IconButton>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            {/*<VacationBankSummary data={dataBank.filter(item => item.year == obj.year)} />*/}
                            <TabBankSummary data={dataBank.filter(item => item.year == obj.year)} typeSolde={1} />
                        </AccordionDetails>
                    </Accordion>
                </React.Fragment>
            )}
            <Dialog fullScreen open={open} onClose={handleCloseClick} TransitionComponent={Transition}>
                <div data-id="headerVacationBankDetail">
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={handleCloseClick} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" className={classes.titleAppBarForm}>
                                {title}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                </div>
                <div data-id="detailVacationBankDetail">
                    <VacationBankDetail data={dataDetailBank}/>
                </div>
            </Dialog>
        </div>
    );
}